import { fromCompact, type SharePayload } from './share-payload';
import { inflateRaw, base64UrlToBytes } from './deflate-base64url';

export async function decodeShare(token: string): Promise<SharePayload | null> {
  const t = token.trim();
  if (!t) return null;
  try {
    const bytes = base64UrlToBytes(t);
    const json = new TextDecoder().decode(await inflateRaw(bytes));
    return fromCompact(JSON.parse(json));
  } catch {
    return null;
  }
}
